(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  document.querySelectorAll('[data-cart-back-link]').forEach((link) => {
    if (!document.referrer) return;

    try {
      const previousPage = new URL(document.referrer);

      if (previousPage.origin === window.location.origin && !/\/cart(?:\/|$)/.test(previousPage.pathname)) {
        link.href = previousPage.href;
      }
    } catch {}
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mr-worldshopping"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', (event) => {
  const link = event.target.closest('.mr-ws__navigation a');
  if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
  const heading = document.getElementById(link.hash.slice(1));
  if (!heading) return;
  event.preventDefault();
  history.replaceState(null, '', link.hash);
  heading.setAttribute('tabindex', '-1');
  heading.focus({ preventScroll: true });
  heading.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
});
document.addEventListener('submit', (event) => {
  const form = event.target;
  if (!(form instanceof HTMLFormElement) || !form.matches('.mr-ws__languages')) return;
  const returnTo = form.querySelector('input[name="return_to"]');
  if (returnTo) {
    const current = new URL(window.location.href);
    current.searchParams.set('view', 'worldshopping');
    returnTo.value = current.pathname + current.search + current.hash;
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mr26-contact-2026"] && !Shopify.designMode) return;
  try {
    
(() => {
  const root = document.querySelector('.mr26-private-contact');
  if (!root) return;
  const form = root.querySelector('form');
  const buttons = [...root.querySelectorAll('[data-contact-category]')];
  const panels = [...root.querySelectorAll('[data-contact-panel]')];
  const value = root.querySelector('[data-contact-value]');
  const select = root.querySelector('[data-contact-select]');
  const activate = (key) => {
    const chosen = buttons.find((button) => button.dataset.contactCategory === key);
    if (!chosen) return;
    buttons.forEach((button) => {
      const active = button === chosen;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-selected', String(active));
    });
    panels.forEach((panel) => {
      const active = panel.dataset.contactPanel === key;
      panel.hidden = !active;
      panel.classList.toggle('is-active', active);
      panel.querySelectorAll('input, select, textarea').forEach((field) => {
        field.disabled = !active;
      });
    });
    if (select) select.value = key;
    if (value) value.value = chosen.textContent.trim();
  };
  activate(select?.value || 'product');
  buttons.forEach((button) => button.addEventListener('click', () => activate(button.dataset.contactCategory)));
  select?.addEventListener('change', () => activate(select.value));
  const dialog = root.querySelector('[data-contact-confirm]');
  const summary = root.querySelector('[data-contact-summary]');
  const review = root.querySelector('[data-contact-review]');
  let confirmed = false;
  const showReview = () => {
    if (!form.reportValidity() || !dialog) return;
    summary.replaceChildren();
    const addRow = (label, text) => {
      const term = document.createElement('dt');
      const detail = document.createElement('dd');
      term.textContent = label;
      detail.textContent = text || '未入力';
      summary.append(term, detail);
    };
    addRow('お問い合わせカテゴリ', value.value);
    const panel = panels.find((item) => !item.hidden);
    panel?.querySelectorAll('input, select, textarea').forEach((field) => {
      if (field.disabled || field.type === 'hidden') return;
      const label = field.closest('label');
      const title = [...label.childNodes].filter((node) => node.nodeType === Node.TEXT_NODE).map((node) => node.textContent).join('').trim();
      addRow(title, field.value);
    });
    confirmed = false;
    dialog.showModal();
    dialog.querySelector('h2').focus();
  };
  review?.addEventListener('click', showReview);
  root.querySelector('[data-contact-edit]')?.addEventListener('click', () => dialog.close());
  dialog?.addEventListener('close', () => { confirmed = false; review.focus(); });
  root.querySelector('[data-contact-send]')?.addEventListener('click', () => { confirmed = true; });
  form?.addEventListener('submit', (event) => {
    if (!confirmed) {
      event.preventDefault();
      showReview();
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
